// Single source of truth for CQC Centre colour/label conventions, mirrored on
// pages/fleetEquipment/makeReady/severity.js so gap severity and evidence
// status read consistently with the rest of the app.
export const GAP_SEVERITY = {
  Critical: { label: 'Critical', color: 'error' },
  Important: { label: 'Important', color: 'warning' },
  Advisory: { label: 'Advisory', color: 'info' },
}

export const EVIDENCE_STATUS = {
  current: { label: 'Current', color: 'success' },
  expiring_soon: { label: 'Expiring Soon', color: 'warning' },
  expired: { label: 'Expired', color: 'error' },
}

// Identity colours for the key-question readiness rings (pack PDF + web).
// AmbuNet brand palette, ordered/adjusted so adjacent rings stay separable:
// anYellow is swapped for the risk-register gold (#CCA43B) — the raw brand
// yellow is invisible as a mark on a white surface — and gold/orange are kept
// non-adjacent for colour-vision-deficiency separation. Overall = anBlue.
export const KEY_QUESTION_COLORS = {
  Safe: '#E32525', // anRed
  Effective: '#CCA43B', // anYellow's chart-safe step
  Caring: '#00964C', // anGreen
  Responsive: '#F28B1F', // anOrange
  'Well-led': '#85276A', // anPurple
}
export const OVERALL_READINESS_COLOR = '#1F3D7C' // anBlue

export const READINESS_BAND = (score) => {
  if (score >= 85) return { label: 'Green', color: 'success' }
  if (score >= 65) return { label: 'Amber', color: 'warning' }
  return { label: 'Red', color: 'error' }
}

export const GAP_STATUS = {
  open: { label: 'Open', color: 'error' },
  resolved: { label: 'Resolved', color: 'success' },
}
